import Vue from "vue";
// import md5 from "js-md5";
import config from "@/config";
import errorTags from "@/errorTags";

export default {
  namespaced: true,
  state: {
    _loading: {
      login: false,
      logout: false,
      getOTP2faStatus: false,
      getOTP2faQrCode: false,
      verifyOTP2fa: false,
      validateOTP2fa: false,
      unbindOTP2fa: false,
    },
    sessionToken: "",
    username: "",
    password: "",
    accessRoles: [],
    alertOn: true,
    otp2faValidated: false
  },
  mutations: {
    update(state, payload) {
      state.sessionToken = payload.sessionToken;
      state.username = payload.user.username;
      state.password = payload.user.password;
      state.accessRoles = payload.user.accessRoles;
      state.otp2faValidated = payload.otp2faValidated;
      state.alertOn = true;
    },
    delete(state) {
      state.sessionToken = "";
      state.username = "";
      state.password = "";
      state.accessRoles = [];
      state.alertOn = null;
      state.otp2faValidated = null;
    },
    loading(state, payload) {
      if ("action" in payload) {
        const action = payload.action;
        const status = payload.status;
        state._loading[action] = status;
      }
    },
    updateAlertOn(state, payload) {
      state.alertOn = payload;
    },
    update2faValidated(state, payload) {
      state.otp2faValidated = payload;
    },
  },
  actions: {
    login(context, user) {
      const url = config.loginUrl();
      const body = {
        user_id: user.username,
        password: user.password
      };
      const feedback = {
        success: false,
        status: errorTags.login.failed,
        redirect: ""
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("username" in user)) {
          feedback.status = errorTags.login.usernameRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("password" in user)) {
          feedback.status = errorTags.login.passwordRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.username.length <= 0) {
          feedback.status = errorTags.login.usernameRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.password.length <= 0) {
          feedback.status = errorTags.login.passwordRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.login == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "login", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", { action: "login", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                feedback.ip = successResponse.body.ip;
                if (feedback.success == true) {
                  var sessionToken = null;
                  var otp2faValidated = null;
                  try {
                    sessionToken = successResponse.body.value.session_token[0].token;
                    otp2faValidated = successResponse.body.value.session_token[0]['2fa_validated'];
                    if (sessionToken) {
                      user.accessRoles = successResponse.body.value.access_right;
                      context.commit("update", { sessionToken, user, otp2faValidated });
                      if (otp2faValidated) {
                        feedback.redirect = "/otp";
                      } else {
                        feedback.redirect = "/monitor/status";
                      }
                      resolve(feedback);
                    } else {
                      context.commit("delete");
                      feedback.success = false;
                      feedback.status = errorTags.login.failed;
                      reject(feedback);
                    }
                  } catch (error) {
                    context.commit("delete");
                    feedback.success = false;
                    feedback.status = errorTags.login.failed;
                    reject(feedback);
                  }
                } else {
                  context.commit("delete");
                  reject(feedback);
                }
              } else {
                // Response is empty...

                context.commit("delete");
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", { action: "login", status: false });
              context.commit("delete");
              feedback.error = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    logout(context) {
      const feedback = {
        success: true,
        status: errorTags.logout.succeed
      };
      return new Promise(resolve => {
        context.commit("delete");
        resolve(feedback);
      });
    },
    setAlertOn(context, payload) {
      context.commit("updateAlertOn", payload);
    },
    set2faValidated(context, payload) {
      context.commit("update2faValidated", payload);
    },

    getOTP2faGet(context) {
      const url = config.getOTP2faGetUrl();
      const body = {
        action_by: this.state.user.username,
        session_token: this.state.user.sessionToken,
        page_id: config.accessRoles.setting,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.otp.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (this.state.user._loading.getOTP2faStatus == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getOTP2faStatus",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getOTP2faStatus",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  var data = null;

                  try {
                    data = successResponse.body.tbl_key_list;
                    // feedback.data = successResponse.body.data.status;
                    feedback.data = data;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.status = errorTags.otp.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getOTP2faStatus",
                status: false
              });
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getOTP2faQrCode(context) {
      const url = config.getOTP2faQrCodeUrl();
      const body = {
        action_by: this.state.user.username,
        session_token: this.state.user.sessionToken,
        page_id: config.accessRoles.setting,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.otp.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (this.state.user._loading.getOTP2faQrCode == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getOTP2faQrCode",
            status: true
          });
          // Request as blob to handle image responses, but also try to parse as JSON
          Vue.http.post(url, body, { responseType: 'blob' }).then(
            successResponse => {
              context.commit("loading", {
                action: "getOTP2faQrCode",
                status: false
              });
              if (successResponse) {
                // Check if response is a blob (image) directly
                if (successResponse.body instanceof Blob) {
                  // Check if it's actually a JSON error response
                  const contentType = successResponse.headers.get('content-type') || '';
                  if (contentType.includes('application/json')) {
                    // It's JSON, parse it
                    successResponse.body.text().then(text => {
                      try {
                        const jsonData = JSON.parse(text);
                        if (typeof jsonData.status == "string") {
                          feedback.success = jsonData.status == "1";
                        } else {
                          feedback.success = jsonData.status == true;
                        }
                        feedback.status = jsonData.statusdesc;
                        if (feedback.success == true) {
                          const responseData = jsonData.data || jsonData;
                          feedback.data = {
                            qr_code: responseData.qr_code || responseData.qrCode || responseData.image || responseData,
                            // secret: responseData.secret || null
                          };
                          resolve(feedback);
                        } else {
                          reject(feedback);
                        }
                      } catch (e) {
                        feedback.success = false;
                        feedback.status = errorTags.otp.failed;
                        reject(feedback);
                      }
                    });
                    return;
                  }
                  // Convert blob to data URL
                  const reader = new FileReader();
                  reader.onloadend = () => {
                    feedback.success = true;
                    feedback.data = {
                      qr_code: reader.result, // data URL
                      secret: null
                    };
                    resolve(feedback);
                  };
                  reader.onerror = () => {
                    feedback.success = false;
                    feedback.status = errorTags.security.failed;
                    reject(feedback);
                  };
                  reader.readAsDataURL(successResponse.body);
                  return;
                }
                
                // Handle JSON response
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    // Handle different response structures
                    const responseData = successResponse.body.data || successResponse.body;
                    feedback.data = {
                      qr_code: responseData.qr_code || responseData.qrCode || responseData.image || responseData,
                      secret: responseData.secret || null
                    };
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.status = errorTags.security.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getOTP2faQrCode",
                status: false
              });
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    verifyOTP2fa(context, user) {
      const url = config.verifyOTP2faUrl();
      const body = {
        action_by: this.state.user.username,
        session_token: this.state.user.sessionToken,
        page_id: config.accessRoles.setting,
        code: user.code
      };
      const feedback = {
        success: false,
        status: errorTags.otp.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("code" in user) || user.code.length <= 0) {
          feedback.status = errorTags.otp.invalidCode;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.verifyOTP2fa == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "verifyOTP2fa",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "verifyOTP2fa",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    // feedback.data = successResponse.body;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.status = errorTags.otp.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "verifyOTP2fa",
                status: false
              });
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    validateOTP2fa(context, user) {
      const url = config.validateOTP2faUrl();
      const body = {
        action_by: this.state.user.username,
        session_token: this.state.user.sessionToken,
        page_id: config.accessRoles.setting,
        code: user.code
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.otp.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("code" in user) || user.code.length <= 0) {
          feedback.status = errorTags.otp.invalidCode;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.validateOTP2fa == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "validateOTP2fa",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              console.log("validateOTP2fa",successResponse.body);
              context.commit("loading", {
                action: "validateOTP2fa",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    // feedback.data = successResponse.body.data.status;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.status = errorTags.otp.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "validateOTP2fa",
                status: false
              });
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    unbindOTP2fa(context, user) {
      const url = config.unbindOTP2faUrl();
      const body = {
        action_by: this.state.user.username,
        session_token: this.state.user.sessionToken,
        page_id: config.accessRoles.setting,
        code: user.code
      };
      const feedback = {
        success: false,
        status: errorTags.otp.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("code" in user) || user.code.length <= 0) {
          feedback.status = errorTags.otp.invalidCode;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.unbindOTP2fa == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "unbindOTP2fa",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "unbindOTP2fa",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.status = successResponse.body.statusdesc;

                if (feedback.success == true) {
                  try {
                    // feedback.data = successResponse.body;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.status = errorTags.otp.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "unbindOTP2fa",
                status: false
              });
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
  }
};
